<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="part1"><a id="pXX"></a><a id="p1"></a>PART I</p>
<p class="pt-orna"><img alt="images" src="images/pt-ornament.jpg"/></p>
<p class="pt">YOUNG CHARLES</p>
<p class="pt-epi"><i>‘We are delighted that our grandson Charles takes so much pleasure in hunting, because otherwise one might think he was a bastard.’</i></p>
<p class="pt-epi-credit">Emperor Maximilian to Margaret of Austria, 28 February 1510</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part_01.vue?4ce45cd2